import React, { useEffect, useState } from "react";
import { DollarSign, Package, Users, Mail, AlertTriangle, ShoppingCart } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-neutral-400">Loading…</div>;

  const cards = [
    ["Revenue (paid)", `$${d.revenue_usd.toLocaleString()}`, DollarSign],
    ["Total Orders", d.orders_total, ShoppingCart],
    ["Products", d.products_total, Package],
    ["Customers", d.customers_total, Users],
    ["Subscribers", d.subscribers_total, Mail],
    ["Low Stock", d.low_stock, AlertTriangle],
  ];
  const statuses = ["processing", "shipped", "delivered", "cancelled", "returned", "refunded"];

  return (
    <div>
      <h1 className="font-serif text-3xl mb-1">Dashboard</h1>
      <p className="text-sm text-neutral-500 mb-8">Scope: {d.scope === "global" ? "Global — all storefronts" : d.scope}</p>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
        {cards.map(([label, val, Icon]) => (
          <div key={label} className="bg-white border border-neutral-200 rounded-lg p-6">
            <div className="flex items-center justify-between mb-3"><span className="text-sm text-neutral-500">{label}</span><Icon size={18} className="text-neutral-400" /></div>
            <div className="text-3xl font-serif">{val}</div>
          </div>
        ))}
      </div>
      <h2 className="font-serif text-xl mb-4">Orders by Status</h2>
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-3">
        {statuses.map((s) => (
          <div key={s} className="bg-white border border-neutral-200 rounded-lg p-4 text-center">
            <div className="text-2xl font-serif">{d.status_counts[s] || 0}</div>
            <div className="text-xs uppercase tracking-wide text-neutral-500 mt-1">{s}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
